export default {
	confirmation: ['modal--confirmation'],
	tabletFullWidth: ['modal--tablet-full-width'],
	footerDivider: ['modal--footer-divider']
};
